<div class="adaptive-grow-1">
    <div class="fluent-container">
        <br />
        <div class="title-color">
            <h1>EDITAR SEGURIDAD SOCIAL</h1>
            <div class="title-lists">
                {{ selectedSocialSecurity?.outsider?.identificationCode }} -
                {{ selectedSocialSecurity?.outsider?.name }}
                {{ selectedSocialSecurity?.outsider?.lastName }}
            </div>
        </div>
        <div class="form-body">
            <form [formGroup]="editSocialSecurityForm" (ngSubmit)="updateSocialSecurity()">
                <div class="line column-md-12">
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Eps</mat-label>
                            <mat-select matInput placeholder="Eps" formControlName="eps">
                                <mat-option *ngFor="let eps of eps" [value]="eps.value">
                                    {{eps.value}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editSocialSecurityForm
                                        .get('eps')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <section class="select-checkbox">
                            <mat-checkbox class="example-margin" formControlName="hasInsurance">¿Tiene seguro?
                            </mat-checkbox>
                        </section>
                    </div>

                    <div class="column-md-4 column-lg-6 column-sm-12">
                        <mat-form-field appearance="outline">
                            <mat-label>Regimen</mat-label>
                            <mat-select matInput placeholder="Regimen" formControlName="insuranceKind">
                                <mat-option *ngFor="let regimen of insuranceKind" [value]="regimen.value">
                                    {{ regimen.value }}
                                </mat-option>
                            </mat-select>
                            <mat-error class="for-text text-danger" *ngIf="
                                    editSocialSecurityForm
                                        .get('insuranceKind')
                                        ?.hasError('required')
                                ">
                                Campo obligatorio
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <button type="submit" class="primary-button" id="guardar">
                    <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
                </button>
                <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
                    <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
                </button>
            </form>
        </div>
    </div>
</div>
